export default function () {
    (function ($) {

        $.validator.setDefaults({
            errorPlacement: function (error, element) {
                var parent = $(element).closest('.middleColumn');

                if ($(element).closest('.custom-checkbox').length) {
                    parent = $(element).closest('.custom-checkbox');
                }

                parent.append(error);
            },
            highlight: function (element, errorClass) {
                var subject = $(element);

                if ($(element).closest('.input-group').length) {
                    subject = $(element).closest('.input-group');
                }

                subject.addClass(errorClass);
            },
            unhighlight: function (element, errorClass) {
                var subject = $(element);

                if ($(element).closest('.input-group').length) {
                    subject = $(element).closest('.input-group');
                }

                subject.removeClass(errorClass);
            },
        });

        $.validator.methods.mobile = function (value, element) {
            const num = value.replace(/ /g, ''); // Remove whitespace
            return this.optional(element) || /^\+\d{10,12}$/.test(num) || /^0\d{8,10}$/.test(num);
        };

        // Login form
        $.fn.initLoginValidation = function () {
            // Adds a custom email validation method that is more strict than the one built-in.
            $.validator.methods.email = function (value, element) {
                return this.optional(element) || /^[A-Za-z0-9\_](([_\.\-]?[a-zA-Z0-9\_]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/.test(value);
            };

            $(this).validate({
                onkeyup: false,
                rules: {
                    Email: {
                        email: true,
                    },
                },
                messages: {
                    Email: {
                        required: 'Please enter your email address',
                        email: 'This is not a correct email format',
                    },
                    Password: 'Please enter your password',
                },
            });
        };

        // email validation only
        $.fn.initEmailValidation = function () {
            // Adds a custom email validation method that is more strict than the one built-in.
            $.validator.methods.email = function (value, element) {
                return this.optional(element) || /^[A-Za-z0-9\_](([_\.\-]?[a-zA-Z0-9\_]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/.test(value);
            };

            $(this).validate({
                onkeyup: false,
                rules: {
                    Email: {
                        email: true,
                    },
                },
                messages: {
                    Email: {
                        required: 'Please enter your email address',
                        email: 'This is not a correct email format',
                    },
                },
            });
        };

        $('.validate-form-login form').initLoginValidation();

        $('.validate-form-email form').initEmailValidation();

        // Validate form
        $('.validate-form form').validate({
            onkeyup: false,
        });
    })(jQuery);
}
